const defaultState = {
  analytics: {
    data: [],
    total: 0,
  },
  payment: [],
}

function dashboard(state = defaultState, action) {
  switch (action.type) {
    case 'GET_PRODUCT_METAS_SUCCESS':
      return {
        ...state,
        analytics: action.payload
      }
    case 'GET_PAYMENT_REPORT_SUCCESS':
      return {
        ...state,
        payment: action.payload
      }
    default:
      return state
  }
}

export default dashboard



// WEBPACK FOOTER //
// ./routes/app/routes/dashboard/reducer/index.js